module.exports = __webpack_public_path__ + "f838ffe900f1dbc9c41df797abf8161d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg68.jpeg
// module id = 81
// module chunks = 0